/**
 * Generated by orval 🍺
 * Do not edit manually.
 * TrainLoop Platform V2 API
 * Model evaluation workbench API
 * OpenAPI spec version: 0.0.0
 */

export type TrainingAgentEventViewType =
  (typeof TrainingAgentEventViewType)[keyof typeof TrainingAgentEventViewType];

export const TrainingAgentEventViewType = {
  user: "user",
  approval_resolved: "approval_resolved",
  status: "status",
  launch_request: "launch_request",
  launch_approved: "launch_approved",
  launch_resolved: "launch_resolved",
  init: "init",
  text: "text",
  tool_use: "tool_use",
  tool_result: "tool_result",
  approval: "approval",
  turn: "turn",
  error: "error",
} as const;
